<template>
  <basic-master
    masterName="船舶"
    insertDataPageName="addon-port-master-vessel-insert"
    viewPageName="addon-port-master-vessel-view"
    @callDelete="callDelete"
    @callSearch="callSearch"
    @updateDisplayItems="updateDisplayItems"
    :storedSearchKeyword="storedSearchKeyword"
    :data="data"
    :columns="columns"
    :pagination="true"
    :totalPages="totalPages"
    :totalItems="totalItems"
    :currentPage="currentPage"
    :displayItems="displayItems"
    :incrementSearch="false"
    :sortable="false"
    :editable="false"
  >
  </basic-master>
</template>

<script>

import BasicMaster from "../components/BasicMaster";
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("portMaster");
export default {
  components: {
    BasicMaster
  },
  data() {
    return {
      totalPages: 0,
      totalItems: 0,
      currentPage: 0,
      displayItems: {
        number: 10
      },
      columns: [
        {
          displayName:"船舶名",
          inputType: "string",
          key: "name",
          searchable: true,
        },
        {
          displayName:"船舶名称",
          inputType: "string",
          key: "label",
          searchable: true,
        },
        {
          displayName:"管理コード",
          inputType: "string",
          key: "admin_code",
          searchable: true,
        },
        {
          displayName:"MMSI",
          inputType: "string",
          key: "mmsi",
          searchable: true,
        },
        {
          displayName:"タグ",
          inputType: "tag",
          key: "tags",
          searchable: false,
        },
      ],
      data: [],
      storedSearchKeyword: "",
      lastSearchCondition: {}
    }
  },
  async created() {
    this.displayItems = {
      number: this.storedMasterSearchCondition.vessel.limit ? this.storedMasterSearchCondition.vessel.limit : 10
    }
    this.refreshData(this.$route.params.lastSearchCondition)
  },
  computed: {
    ...mapState({
      selectedPort: state => state.selectedPort,
      storedMasterSearchCondition: state => state.storedMasterSearchCondition
    }),
  },
  methods: {
    ...mapActions(["fetchVessels", "updateVessel", "deleteVessel", "searchVessels", "setStoredMasterSearchCondition"]),
    updateDisplayItems(number) {
      this.displayItems = number
    },
    async refreshData(lastSearchCondition) {
      let query = {}
      if (lastSearchCondition) {
        query = lastSearchCondition
        this.currentPage = lastSearchCondition.page
        this.storedSearchKeyword = lastSearchCondition.name ? lastSearchCondition.name : ""
      } else {
        query = {
          limit: this.displayItems.number,
          page: this.currentPage,
        }
      }
      let payload = {
        portId: this.selectedPort.id,
        query: query
      }
      this.$vs.loading()
      this.setStoredMasterSearchCondition({ ...this.storedMasterSearchCondition, vessel: payload.query }) // ページ表示件数を永続化するため検索条件を保存
      let res = await this.searchVessels(payload)
      this.$vs.loading.close()
      this.data = res.vessels
      this.totalPages = res.pageable.total_pages
      this.totalItems = res.pageable.total_elements
    },
    async callSearch(condition) {
      if (Object.prototype.hasOwnProperty.call(condition, "keyword")) this.storedSearchKeyword = condition.keyword
      let payload = {
        portId: this.selectedPort.id,
        query: {
          limit: condition.limit,
          page: condition.page,
        }
      }
      if (this.storedSearchKeyword) payload.query.name = this.storedSearchKeyword // TODO: 検索の仕様確認
      this.$vs.loading()
      this.setStoredMasterSearchCondition({ ...this.storedMasterSearchCondition, vessel: payload.query }) // ページ表示件数を永続化するため検索条件を保存
      let res = await this.searchVessels(payload)
      this.$vs.loading.close()
      this.data = res.vessels
      this.totalPages = res.pageable.total_pages
      this.totalItems = res.pageable.total_elements
      this.currentPage = condition.page

      this.lastSearchCondition = condition
    },
    async callDelete(id) {
      let payload = {
        portId: this.selectedPort.id,
        id: id,
      }
      this.$vs.loading()
      await this.deleteVessel(payload)
      this.$vs.notify({
        title: "データを削除しました。",
        color: "danger",
        iconPack: "feather",
        icon: "icon-check",
        position: "top-center"
      })
      this.$vs.loading.close()
      let condition = {
        limit: this.displayItems.number,
        page: 0,
      }
      this.callSearch(condition)
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
